'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Heading, KeyValueTable } from '@petsmart-ui/sparky';
import { orderSummaryRows } from './constants';
import { EarnedPoints } from './EarnedPoints';
import { KeyValueRow } from './KeyValueRow';
import type { PaymentMethodPreviewProps } from './PaymentMethodPreview';
import { PaymentMethodPreview } from './PaymentMethodPreview';
import type { OrderSummaryRow } from './types';
export interface OrderSummaryViewProps {
  title?: string;
  earnedPoints?: number;
  paymentMethod?: PaymentMethodPreviewProps['paymentMethod'];
  rows: OrderSummaryRow[];
  futurePromisedShipDate?: string;
  promisedShipDate?: string;
}
export function OrderSummaryView(t0) {
  const $ = _c(16);
  const {
    rows,
    title,
    earnedPoints,
    paymentMethod,
    futurePromisedShipDate,
    promisedShipDate
  } = t0;
  const t1 = title ?? (futurePromisedShipDate ? "Autoship enrollment summary" : "Order summary");
  let t2;
  if ($[0] !== t1) {
    t2 = <Heading tagName="h2" size="headline" className="sparky-u-margin-bottom-md">{t1}</Heading>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== rows) {
    t3 = rows.map(_temp);
    $[2] = rows;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <KeyValueTable fullWidth={true} className="sparky-u-margin-bottom-sm">{t3}</KeyValueTable>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== earnedPoints) {
    t5 = earnedPoints !== undefined && <EarnedPoints points={earnedPoints} />;
    $[6] = earnedPoints;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== paymentMethod || $[9] !== promisedShipDate) {
    t6 = paymentMethod && <PaymentMethodPreview paymentMethod={paymentMethod} promisedShipDate={promisedShipDate} />;
    $[8] = paymentMethod;
    $[9] = promisedShipDate;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Box className="order-summary">{t2}{t4}{t5}{t6}</Box>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(row, index) {
  return <KeyValueRow {...orderSummaryRows[row.key]?.getProps(row)} key={`${row.key}_${String(index)}`} />;
}